
import React from 'react';
import { Bike } from '@/services/types';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { AddBikeForm } from './AddBikeForm';
import { EditBikeForm } from './EditBikeForm';

interface BikeDialogsProps {
  selectedBike: Bike | null;
  showAddDialog: boolean;
  showEditDialog: boolean;
  setShowAddDialog: (show: boolean) => void;
  setShowEditDialog: (show: boolean) => void;
  handleAddBike: (event: React.FormEvent<HTMLFormElement>) => void;
  handleEditBike: (event: React.FormEvent<HTMLFormElement>) => void;
  loading: boolean;
}

export const BikeDialogs: React.FC<BikeDialogsProps> = ({
  selectedBike,
  showAddDialog,
  showEditDialog,
  setShowAddDialog,
  setShowEditDialog,
  handleAddBike,
  handleEditBike,
  loading
}) => {
  return (
    <>
      {selectedBike && (
        <Dialog open={showEditDialog} onOpenChange={setShowEditDialog}>
          <DialogContent>
            <DialogHeader>
              <DialogTitle>Редактировать данные велосипеда</DialogTitle>
              <DialogDescription>
                Измените данные велосипеда {selectedBike.serialNumber}
              </DialogDescription>
            </DialogHeader>
            <EditBikeForm 
              bike={selectedBike} 
              onSubmit={handleEditBike} 
              loading={loading} 
            />
          </DialogContent>
        </Dialog>
      )}

      <Dialog open={showAddDialog} onOpenChange={setShowAddDialog}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Добавить новый велосипед</DialogTitle>
            <DialogDescription>
              Заполните данные для добавления нового велосипеда в систему
            </DialogDescription>
          </DialogHeader>
          <AddBikeForm onSubmit={handleAddBike} loading={loading} />
        </DialogContent>
      </Dialog>
    </>
  );
};
